<template>
  <main>
    <!-- <pre>{{status}}</pre> -->
    <!-- <Splash :class="{hide: status !== 'empty'}" /> -->
    <Loader :class="{hide: status !== 'empty' || status === 'updating'}" />
    <!-- <div v-if="status === 'updating'">Show small loader</div> -->
    <component :is="layout" :entry="entry" class="content-generator">
      <template v-if="status === 'idle' || status === 'updating'">
        <ContentRenderer v-for="(section, index) in entry.content" v-if="entry && entry.content" :content="section" />
      </template>
    </component>
  </main>
</template>

<script>


import { collectionModuleName } from '@/store'
import ContentRenderer from '@/components/bard-renderer/ContentRenderer'
import RootLayout from '@/layouts/RootLayout'
import DetailLayout from '@/layouts/DetailLayout'
import Splash from '@/components/splash/Splash'
import Loader from '@/components/loader/Loader'

let storeModule = undefined

export default {
  components: {
    ContentRenderer,
    RootLayout,
    DetailLayout,
    Splash,
    Loader
  },
  computed: {
    status () {
      return this.$store.state[storeModule].status
    },
    entry () {
      const entryIdentitier = this.$route.params.slug ? this.$route.params.slug : this.$route.params.collection
      // if (!this.$store.getters[storeModule + '/getEntry'](entryIdentitier)) this.$router.push('/404')
      return this.$store.getters[storeModule + '/getEntry'](entryIdentitier)
    },
    layout () {
      if (this.entry && this.entry.layout && this.entry.layout.value === 'root') {
        return 'RootLayout'
      }
      if (this.entry && this.entry.layout && this.entry.layout.value === 'detail') {
        return 'DetailLayout'
      }
      return 'div'

    }
  },
  created () {
    this.routeUpdate(this.$route.params)

  },
  methods: {
    async routeUpdate (params) {
      let {collection, slug} = params
      if(!slug) {
        slug = collection
        collection = 'pages'
      }
      // TODO: 404
      try {
        storeModule = collectionModuleName(collection)
        await this.$store.dispatch(`${storeModule}/fetchEntry`, {collection, slug})
      } catch (err) {
        console.log('Page content can not be loaden', err)
        this.$router.replace({name: '404'})
      }

    }
  },
  beforeRouteUpdate (to, from, next) {
    // TODO: Onbefore route leave is slow. See if we can make this faster
    this.routeUpdate(to.params)
    next()
  }
}
</script>
